import { useToggle } from "client/hooks/utils/useToggle";
import { translateFunc } from "client/utils/translateFunc";
import { FontSpacingIcon } from "components/common/Icons/FontSpacingIcon";
import { Popup } from "components/common/Popup/Popup";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useFindTextBox } from "../useFindTextBox";
import { FontSpacingOptions } from "./FontSpacinOptions/FontSpacingOptions";

export interface FontSpacingProps {
    textBoxId: string;
}

export const FontSpacing = ({ textBoxId }: FontSpacingProps) => {
    const { textBox } = useFindTextBox(textBoxId);
    const { isOpen, onClose: close, toggle } = useToggle();
    return (
        <Popup isOpen={isOpen} close={close} content={<FontSpacingOptions textBox={textBox} />}>
            <ToolTip text={translateFunc("text-spacing")}>
                <button
                    className={`w-10 h-10 flex items-center justify-center ${
                        isOpen
                            ? "bg-irGray-200 dark:bg-darkSurface-300"
                            : "hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
                    } rounded-lg`}
                    onClick={toggle}
                >
                    <FontSpacingIcon />
                </button>
            </ToolTip>
        </Popup>
    );
};
